module.exports = __webpack_public_path__ + "static/media/GroupWarningIcon.e69596f4.svg";